
export const DataCachePreload = (userState: any) => (
    [
        {
            schema: 'user',
            page: 1,
            pageSize: 200,
        },
    ]
);